import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import Field from '../../../components/shared/Field'
import { useServiceContext } from '../../../root'
import type { FileWithMetadata, DocumentMigrationFormData } from './types'

interface FileMergeProps {
  files: FileWithMetadata[]
  values?: DocumentMigrationFormData
}

const supportedExtensions = ['png', 'jpg', 'jpeg']

const FileMerge: React.FC<FileMergeProps> = ({ files, values }) => {
  const context = useServiceContext()
  const { translate } = context.service.filter
  const [canMerge, setCanMerge] = useState(false)

  useEffect(() => {
    const checkIfMergable = (files: FileWithMetadata[]) => {
      if (files?.length > 1) {
        const extensions = files.map((file) => file.name.split('.').pop()?.toLowerCase() || '')
        const allSameExtension = extensions.every((ext) => ext === extensions[0])
        const isSupported = supportedExtensions.includes(extensions[0] || '')
        if (allSameExtension && isSupported) {
          setCanMerge(true)
        } else {
          setCanMerge(false)
          if (context.store?.formRef?.setFieldValue) {
            context.store.formRef.setFieldValue('combineImages', false)
          }
        }
      } else {
        setCanMerge(false)
        if (context.store?.formRef?.setFieldValue) {
          context.store.formRef.setFieldValue('combineImages', false)
        }
      }
    }
    checkIfMergable(files)
  }, [files])

  return (
    <>
      {canMerge && (
        <Field
          className="pl0 merge-file-checkbox"
          name="combineImages"
          checked={values?.combineImages}
          as={Form.Check}
          type="checkbox"
          id="2549359a-7890-4a5c-b294-a22bb5c7d730"
        >
          <span className="fs12-imp fw-700">{translate('MERGE_IMG_TO_CREATE_SINGLE_DOC')}</span>
        </Field>
      )}
    </>
  )
}

export default FileMerge
